module.exports = __webpack_public_path__ + "media/images/browsers/sleipnir-3131c3510299682637f35f1848463f0b.svg";